import { post } from '@/util/http'
// 应用发布升级管理

// 分页查询升级包
export const selectPageVersionUpdate = params => post(`/common/versionUpdate/selectPage`, params)

/**
 * 分页获取模糊查询列表
 * @param fuzzyText
 *            模糊查询字符串
 * @param current
 *            第几页
 * @param size
 *            每页几条记录
 */
export const selectPageByFuzzy = params => post(`/common/versionUpdate/selectPageByFuzzy`, params)

/**
 * 获取首次发布应用列表
 */
export const selectFirstReleaseList = params => post(`/common/versionUpdate/selectFirstReleaseList`, params)

// 新增升级包记录
export const insertVersionUpdate = params => post(`/common/versionUpdate/insert`, params)

// 更新升级包记录
export const updateVersionUpdate = params => post(`/common/versionUpdate/update`, params)

/**
 * 删除升级包记录
 * @param params id 版本升级记录ID
 */
export const deleteVersionUpdate = params => post(`/common/versionUpdate/delete`, params)

/**
 * 根据包文件名称删除该包文件
 * @param params packageName 包文件名称
 */
export const deleteFileByPackageName = params => post(`/common/versionUpdate/deleteFileByPackageName`, params)
